import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './CreateCategoryModal.css';

export default class CreateCategoryModal extends React.Component {
  render() {
    const { onConfirm, onCancel, show } = this.props;
    let { newCategory } = this.props;
    if (!newCategory) {
      newCategory = '';
    }
    return (
      <Modal className={styles['modal-container']} show={show}>
        <Modal.Header>
          <Modal.Title className={styles['modal-title']}>
            Information
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            Are you sure want to create <span>{newCategory}</span>?
          </div>
        </Modal.Body>
        <Modal.Footer>
          <span className="pull-right">
            <button className="btn btn-default" onClick={onCancel}>
              Cancel
            </button>
            <button className="btn btn-primary" onClick={onConfirm}>
              Ok
            </button>
          </span>
        </Modal.Footer>
      </Modal>
    );
  }
}
